import Config from 'app/common/Config';

__webpack_public_path__ = `${Config.mediaUrl}build/`;
